import { Team } from 'contexts/teams/types';

// Expects the user's team memberships (session.user.teams): the account teams list (GET /teams/)
// has no is_manager. Team.is_manager is string | boolean because GET /teams/ sends a string (or
// omits it) while users/me sends a real boolean; String(...) normalizes both without treating the
// string "false" as truthy.
export const canManageTeamDeadline = (
  isAccountOwner: boolean,
  userTeams: Team[] | null | undefined,
  teamId: string
): boolean => {
  if (isAccountOwner) return true;

  const managedTeam = userTeams?.find((team) => team.id === teamId || team.team_id === teamId);
  return String(managedTeam?.is_manager) === 'true';
};
